import { j as e } from "./utils-BdNIfrGQ.js";
import { useState as L, useMemo as C } from "react";
import { T as g } from "./Text-BhLXzYEf.js";
import { D as d } from "./Div-spVpsZsH.js";
import N from "./components/select/Select.mjs";
import k from "./components/avatar/Avatar.mjs";
import "./Div.skeleton-DLnqOZrU.js";
import { F as p } from "./Flex-BA9xHq_p.js";
import { L as v } from "./List-L_RxfO5h.js";
import "./Grid-DJGISvmf.js";
import { a as u } from "./Button-CzIiGCVn.js";
import S from "./components/separator/Separator.mjs";
import { u as M } from "./ResponsiveProvider-BC7BKjLV.js";
import { N as I } from "./NavLink-D9Qfouy1.js";
import { S as U, a as w } from "./SheetClose-DMQa2Yq1.js";
import { c as V } from "./createLucideIcon-D4r5Phnh.js";
const F = [
  ["path", { d: "M4 12h16", key: "1lakjw" }],
  ["path", { d: "M4 18h16", key: "19g7jn" }],
  ["path", { d: "M4 6h16", key: "1o0s65" }]
], j = V("menu", F), x = {
  code: "en-US",
  label: "English (United States)"
}, y = (a) => {
  if (!a) return "";
  const t = a.trim().split(" "), l = [...t[0] || ""], n = [...t[1] || ""], i = l[0]?.toUpperCase() || "", o = n[0]?.toUpperCase() || "";
  return i + o;
}, z = ({ user: a, links: t, sessionActions: l }) => {
  const n = y(a?.name || null), { signOut: i, signIn: o } = l || {};
  return a ? /* @__PURE__ */ e.jsxs(p, { className: "flex-col w-full", gap: "5", children: [
    /* @__PURE__ */ e.jsxs(p, { className: "flex-row flex-nowrap items-center", children: [
      /* @__PURE__ */ e.jsx(k, { profileImage: a.avatar, fallback: n, spacing: "0 5 0 0" }),
      /* @__PURE__ */ e.jsx(g, { fontWeight: "bold", children: a.name })
    ] }),
    t && /* @__PURE__ */ e.jsx(v, { gap: "5", children: t.map(({ children: r, id: c }) => /* @__PURE__ */ e.jsx("li", { className: "pl-6 pr-4", children: r }, c)) }),
    /* @__PURE__ */ e.jsx(u, { onClick: i?.onClick, variant: "outline", children: i?.label || "Sign out" })
  ] }) : /* @__PURE__ */ e.jsx(u, { onClick: o?.onClick, children: o?.label || "Sign in" });
}, P = {
  links: []
}, T = {
  availableLocales: [x],
  onValueChange: () => null,
  selectedValue: x.code
}, Y = ({
  children: a,
  title: t = "Menu",
  languageSelector: l = T,
  userContext: n = P,
  navLinks: i,
  menuGroups: o = [],
  ...r
}) => {
  const [c, b] = L(l.selectedValue), h = C(
    () => l.availableLocales.map((s) => ({
      value: s.code,
      itemLabel: s.label
    })),
    [l.availableLocales]
  ), { isMobile: f } = M();
  return /* @__PURE__ */ e.jsx(
    U,
    {
      trigger: {
        variant: "outline",
        size: f ? "icon" : "default",
        children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(j, { size: 16, strokeWidth: 2, className: "md:mr-3" }),
          /* @__PURE__ */ e.jsx(g, { spacing: "0 3", variant: `${f ? "mobile-hidden" : "visible"}`, children: t })
        ] })
      },
      sheetTitle: {
        icon: /* @__PURE__ */ e.jsx(j, { size: 16, strokeWidth: 2, className: "md:mr-3" }),
        text: t
      },
      width: "navigation",
      fixedFooter: {
        footerBuffer: "pt-[210px]",
        footerContent: /* @__PURE__ */ e.jsx(z, { ...n })
      },
      ...r,
      children: /* @__PURE__ */ e.jsxs("nav", { "aria-label": t, className: "flex flex-col h-full", children: [
        /* @__PURE__ */ e.jsxs(d, { className: "flex flex-col flex-1", children: [
          /* @__PURE__ */ e.jsx(v, { direction: "vertical", gap: "6", spacing: "6 0 0", children: i.map(({ id: s, children: m }) => /* @__PURE__ */ e.jsx("li", { className: "mx-7 py-3 font-semibold", children: /* @__PURE__ */ e.jsx(w, { asChild: !0, children: /* @__PURE__ */ e.jsx(I, { variant: "nav", id: s, children: m }) }) }, s)) }),
          o?.map((s, m) => /* @__PURE__ */ e.jsxs(d, { spacing: "6 0 0", children: [
            /* @__PURE__ */ e.jsx(S, { spacing: "6 0" }),
            /* @__PURE__ */ e.jsx(d, { className: "mx-7 mt-6", children: s })
          ] }, m))
        ] }),
        a,
        h.length > 1 && /* @__PURE__ */ e.jsx(p, { spacing: "6 7 0 7", className: "flex-col", children: /* @__PURE__ */ e.jsx(
          N,
          {
            id: "locale-selector",
            selectLabel: {
              children: "Locale selector",
              htmlFor: "locale-selector",
              variant: "hidden"
            },
            selectList: [{ items: h }],
            triggerLabel: "Locale",
            defaultValue: x.code,
            onValueChange: (s) => {
              l.onValueChange(s), b(s);
            },
            value: c,
            width: "full"
          }
        ) })
      ] })
    }
  );
};
export {
  Y as H
};
